import { Component } from '@angular/core';

@Component({
  selector: 'app-general-ranking-image',
  templateUrl: './general-ranking-image.component.html',
  styleUrls: ['./general-ranking-image.component.scss'],
})
export class GeneralRankingImageComponent {}
